'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = WidgetLibraryRoutes;

var _widgetLibraryTpl = require('./widget-library.tpl.html');

var _widgetLibraryTpl2 = _interopRequireDefault(_widgetLibraryTpl);

var _widgetEditorTpl = require('./widget-editor.tpl.html');

var _widgetEditorTpl2 = _interopRequireDefault(_widgetEditorTpl);

var _dashboardTpl = require('../dashboard/dashboard.tpl.html');

var _dashboardTpl2 = _interopRequireDefault(_dashboardTpl);

var _widgetsBundlesTpl = require('./widgets-bundles.tpl.html');

var _widgetsBundlesTpl2 = _interopRequireDefault(_widgetsBundlesTpl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

function WidgetLibraryRoutes($stateProvider) {
    $stateProvider.state('home.widgets-bundles', {
        url: '/widgets-bundles',
        params: { 'topIndex': 0 },
        module: 'private',
        auth: ['SYS_ADMIN', 'TENANT_ADMIN'],
        views: {
            "content@home": {
                templateUrl: _widgetsBundlesTpl2.default,
                controller: 'WidgetsBundleController',
                controllerAs: 'vm'
            }
        },
        data: {
            searchEnabled: true,
            pageTitle: 'widgets-bundle.widgets-bundles'
        },
        ncyBreadcrumb: {
            label: '{"icon": "now_widgets", "label": "widgets-bundle.widgets-bundles"}'
        }
    }).state('home.widgets-bundles.widget-types', {
        url: '/:widgetsBundleId/widgetTypes',
        params: { 'topIndex': 0 },
        module: 'private',
        auth: ['SYS_ADMIN', 'TENANT_ADMIN'],
        views: {
            "content@home": {
                templateUrl: _widgetLibraryTpl2.default,
                controller: 'WidgetLibraryController',
                controllerAs: 'vm'
            }
        },
        data: {
            searchEnabled: false,
            pageTitle: 'widget.widget-library'
        },
        ncyBreadcrumb: {
            label: '{"icon": "now_widgets", "label": "{{ vm.widgetsBundle.title }}", "translate": "false"}'
        }
    }).state('home.widgets-bundles.widget-types.widget-type', {
        url: '/:widgetTypeId',
        module: 'private',
        auth: ['SYS_ADMIN', 'TENANT_ADMIN'],
        views: {
            "content@home": {
                templateUrl: _widgetEditorTpl2.default,
                controller: 'WidgetEditorController',
                controllerAs: 'vm'
            }
        },
        params: {
            widgetType: null
        },
        data: {
            searchEnabled: false,
            pageTitle: 'widget.editor'
        },
        ncyBreadcrumb: {
            label: '{"icon": "insert_chart", "label": "{{ vm.widget.widgetName }}", "translate": "false"}'
        }
    }).state('widgetEditor', {
        url: '/widget-editor',
        module: 'private',
        auth: ['SYS_ADMIN', 'TENANT_ADMIN'],
        views: {
            "@": {
                templateUrl: _dashboardTpl2.default,
                controller: 'DashboardController',
                controllerAs: 'vm'
            }
        },
        data: {
            widgetEditMode: true,
            searchEnabled: false,
            pageTitle: 'widget.editor'
        }
    });
}


// WEBPACK FOOTER //
// ./src/app/widget/widget-library.routes.js